<div class="flex items-center text-gray-700 dark:text-gray-400">
  <div class="block text-right text-sm sm:text-left">
    <div class="font-medium">
      {{ userName() }}
    </div>
    <div class="text-xs text-gray-500 dark:text-gray-400">
      {{ userRole() }}
    </div>
  </div>
</div>
